//Library Imports
import FadeIn from "react-fade-in";
import { connect } from "react-redux";

// application components goes here
import { WELCOME_DELAY, WELCOME_TRANSITION_DURATION } from "../../../../constants/index";
import roy from "../../../../assets/img/icons/roy.svg";

// styles goes here
import { keyframes } from "styled-components";
import styled from "styled-components";

const OnBoarding3: React.FC = (props) => {
  return (
    <div className="onBoarding">
      {/* third intro text */}
      <FadeIn delay={WELCOME_DELAY} transitionDuration={WELCOME_TRANSITION_DURATION}>
        <AnimationWrapper>
          <div className="welcome-text third-intro fade-in">
            <div className="d-flex max-width-75">
              <img src={roy} alt="step 1" className="margin-xl roy-dp" />
              <div className="heading">
                <h4>
                  With tools that help you <span className="green-text">create, curate and deploy </span> the most
                  timely & relevant content-based campaigns
                </h4>
              </div>
            </div>
          </div>
        </AnimationWrapper>
      </FadeIn>
    </div>
  );
};

export default connect()(OnBoarding3);

const fadeOut = keyframes`
0%{
  opacity: 1
}
100%{
 opacity: 0
}
`;
const AnimationWrapper = styled.div`
  display: flex;
  .welcome-text {
    animation-name: ${fadeOut};
    animation-delay: 2s;
    animation-duration: 2s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-timing-function: ease-all;
  }
`;
